<template>
	<div class="wrapper">

		<!-- COVER FILL -->
		<div
			class="cover-fill"
			:class="{ 'is-fading': isFading }">
		</div>

		<!-- LOGIN -->
		<div class="kleptos-login">
			<div
				class="kleptos-login-panel"
				:class="{ 'is-transit': isFading }">

				<!-- HEADER -->
				<header class="kleptos-login-header">
					<router-link to="/">
						<img width="280" class="mb-2" src="~@/assets/img/kleptobreaker-logo--glow-15@2x.png" alt="Kleptobreaker - New Year">
					</router-link>
				</header>

				<!-- IF FAILURE -->
				<!-- <div class="alert alert-warning alert-dismissible fade show" role="alert">
					<strong>Oops!</strong> That's incorrect.
				</div> -->

				<!-- FORM -->
				<form class="kleptos-login-panel-form" autocomplete="on">

			    	<!-- USERNAME -->
			    	<div class="form-group mb-0">
			    		<input
			    			class="form-username form-control rounded-top"
			    			v-model="email"
			    			type="text"
			    			name="Email"
			    			maxlength="255"
			    			autocapitalize="off"
			    			placeholder="Email"
			    			required>
			    	</div>

			    	<!-- PASSWORD -->
			    	<div class="form-password form-group mb-3">
			    		<input
				    		class="form-control rounded-bottom"
				    		v-model="password"
				    		name="Password"
				    		type="password"
				    		placeholder="Password"
				    		required>
			    	</div>

					<!-- FORGOT? -->
					<!-- <div class="text-right">
						<a class="forgot-password" href="#password-reset">Forgot something?</a>
					</div> -->

					<!-- REMEMBER ME -->
					<!-- <div class="remember-me text-left mb-1">
						<input id="remember-me" name="remember-me" type="checkbox" checked>&nbsp; <label for="remember-me">Remember me</label>
					</div> -->

					<!-- CREATE ACCOUNT? -->
					<div class="mb-4">
						<p>No account? <router-link to="/sign-up/">Create one</router-link></p>
					</div>

					<!-- LOGIN -->
					<div>
						<button
							type="submit"
							class="btn-submit btn btn-primary btn-lg"
							:disabled="processing"
							@click.prevent="login">

							<!-- SPINNER -->
							<svg
								v-if="processing"
								class="spinner"
								viewBox="0 0 50 50">

								<circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
							</svg>

							<!-- LOGIN TEXT -->
							<span v-if="!processing">LOGIN</span>

						</button>
					</div>

				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import firebase from '@/config/firebase';

	export default {
		name: 'login',
		data(){
			return {
				email: '',
				password: '',
				processing: false,
				isFading: false
			}
		},
		methods: {
			login(){
				this.processing = true;


				// this.isFading = true; return; // remove this line

				firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
					(user) => {
						this.isFading = true;

						setTimeout(() => {
							this.$router.replace('/start/');
						}, 3000);
					},
					(err) => {
						alert('Oops. ' + err.message);
						this.processing = false;

						// this.$store.dispatch('logUser', true);
					}
				);
			}
		}
	}
</script>

<style lang="scss" scoped>

	//-----------------------------------------------------------------
	// WRAPPER
	//-----------------------------------------------------------------

	.wrapper {
		display: flex;
		height: 100%;
	}

	//-----------------------------------------------------------------
	// COVER FILL
	//-----------------------------------------------------------------

	.cover-fill {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url(~@/assets/img/quick-blur.png) no-repeat center center;
		background-size: cover;
		transition: opacity 2s 0.0s ease;

		&.is-fading {
			opacity: 0;
		}
	}

	//-----------------------------------------------------------------
	// FILM GRAIN
	//-----------------------------------------------------------------

	.cover-fill:after {
		// content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url(~@/assets/img/grain@2x.png);
		background-size: 100px;
		animation: grain-filter 0.25s steps(2) infinite;
		opacity: 0.4; //0.4
		pointer-events: none;
		z-index: 2;
	}

	@keyframes grain-filter {
	    0% { transform: rotate(0deg); }
	    100% { transform: rotate(-360deg); }
	}

	//-----------------------------------------------------------------
	// LOGIN
	//-----------------------------------------------------------------

	.kleptos-login {
		display: flex;
		width: 100%; //450px;
		height: 100%;
		margin: auto;
	    padding: $spacer*3 $spacer*2;
	    // background: black;
	    text-align: center;
	    z-index: 1;
	}

	//-----------------------------------------------------------------
	// LOGIN PANEL
	//-----------------------------------------------------------------

	.kleptos-login-panel {
		// width: 300px;
		width: 100%;
		max-height: 1000px;
	    margin: auto;
	    color: #cccccc;
	    // border: 1px dashed grey;
	    overflow: hidden;
        transition: max-height 1.3s 1.1s cubic-bezier(0, 1, 0.5, 1);

	    &.is-transit {
	    	max-height: 130px;

	    	.form-username {
				transform: translateX(-430px);
				opacity: 0;
				transition: transform 0.5s 1.0s cubic-bezier(0.23, 1, 0.32, 1),
							opacity 0.5s 1.0s cubic-bezier(0.23, 1, 0.32, 1);
	    	}

	    	.form-password {
				transform: translateX(430px);
				opacity: 0;
				transition: transform 0.5s 1.0s cubic-bezier(0.23, 1, 0.32, 1),
							opacity 0.5s 1.0s cubic-bezier(0.23, 1, 0.32, 1);
	    	}

	    	.kleptos-login-panel-form {
	    		opacity: 0;
	    	}
	    }
	}

	//-----------------------------------------------------------------
	// LOGIN PANEL FORM
	//-----------------------------------------------------------------

	.kleptos-login-panel-form {
		width: 300px;
		margin: 0 auto;
		transition: opacity 0.35s 1.65s ease;

		// https://stackoverflow.com/questions/2781549/removing-input-background-colour-for-chrome-autocomplete
		// Change the white to any color
	    input:-webkit-autofill,
	    input:-webkit-autofill:hover,
	    input:-webkit-autofill:focus
	    input:-webkit-autofill,
	    textarea:-webkit-autofill,
	    textarea:-webkit-autofill:hover
	    textarea:-webkit-autofill:focus,
	    select:-webkit-autofill,
	    select:-webkit-autofill:hover,
	    select:-webkit-autofill:focus {
	      // border: none !important;
	      -webkit-text-fill-color: inherit !important;
	      -webkit-box-shadow: 0 0 0px 1000px white inset; //#eff1f4
	      transition: background-color 5000s ease-in-out 0s;
	    }

	    input:not(:checked) {
	        display: block;
	        padding: rem-calc(15 20);
	        border: 0;
	        border-radius: 0;
	        // background: yellow;
	        text-align: center;
	    }

	    input.form-username {
	    	border-bottom: 1px solid #d9d9d9;
	    }

	    .forgot-password {
	        font-size: 14px;
	    }

	    //-----------------------------------------------------------------
	    // SUBMIT BUTTON
	    //-----------------------------------------------------------------

	    .spinner {
	    	position: relative;
	    	top: 1px;
	    	width: 20px;
	    	height: 20px;

	    	.path {
	    		stroke: #222;
	    	}
	    }

	    //============================================
	    // ANCHORS
	    //============================================

	    a {
	    	// color: #749e9e !important; //#e5264e; // red
	    	color: #8cbc5c;
	    }

	    .btn-submit {
	    	display: flex;
	    	align-items: center;
	    	justify-content: center;
	    	min-width: rem-calc(100);
	    	height: rem-calc(40);
	    	margin: 0 auto rem-calc(15) auto;
	    	// box-shadow: 0 0 10px 5px rgba(#2c767f, 0.2);
	    	background: linear-gradient(to bottom, rgba(#d4dbdb,1) 0%,rgba(#b4bfbc,0.6) 100%);
	    	font-family: 'Bebas Neue';
	    	font-size: rem-calc(20); //19
	    	font-weight: 300;
	    	line-height: 0;
	    	color: #222;
	    	text-shadow: 0 1px 0 rgba(white, 0.2);
	    	transition: all ease 300ms;

			&.active {
				opacity: 0.9;
				background: linear-gradient(to bottom, rgba(#d4dbdb,1) 0%,rgba(#b4bfbc,0.5) 100%) !important;
			}
	    }
	}
</style>